/**
 * Only 401 is a session/auth failure that should refresh/retry/logout.
 * 403 is authorization (e.g. unauthorized purchased loan) and must reject to callers.
 */
export function shouldHandleAsSessionAuthFailure(
  errorStatus?: number | null
): boolean {
  return errorStatus === 401;
}
